var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyhistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 780,
    viewBox: "0 0 360 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 884,
    transform: "translate(-22.6909 -15.2188)",
    fill: "url(#paint0_radial_5706_16833)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5706_16833)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.809,
    cy: 724.781,
    rx: 99.5,
    ry: 144,
    fill: "#FF6700",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5706_16833",
    x: -31.6909,
    y: 380.781,
    width: 599,
    height: 688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_5706_16833"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5706_16833",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-131 -174) rotate(64.052) scale(1474.1 1474.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D134D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567308,
    stopColor: "#0D0616"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyhistory);
export default __webpack_public_path__ + "static/media/family history.bbdb7bf8ea1cdeb8c857207e3966f36d.svg";
export { ForwardRef as ReactComponent };